/**
 * This function checks if two objects are equal
 * @param {Object} obj1 - The first object
 * @param {Object} obj2 - The second object
 * @returns {Boolean} - True if the objects are equal, false otherwise
 */
export const shallowCompareArray = (curr, prev) => {
  if (curr.length !== prev.length) {
    return false;
  }
  for (let i = 0; i < curr.length; i++) {
    if (curr[i] !== prev[i]) {
      return false;
    }
  }
  return true;
};

/**
 * This function adds or removes a layer from the map
 * @param {Object} mapRef - The map object
 * @param {Object} layer - The layer object
 */
export function addAndRemoveLayer(mapRef, layer) {
  if (mapRef.getLayer(layer.layer.id)) {
    mapRef.removeLayer(layer.layer.id);
  }
  if (layer.before_id) {
    mapRef.addLayer(layer.layer, layer.before_id);
  } else {
    mapRef.addLayer(layer.layer);
  }
}

/**
 * This function returns a hover layer for a given layer
 * @param {Object} layer - The layer object
 * @returns {Object} - The hover layer object
 */
export function getHoverLayer(layer) {
  const layerHover = JSON.parse(JSON.stringify(layer));
  layerHover.layer.id = layer.layer.id + "-hover";

  if (layer.layer.type === "circle") {
    layerHover.layer.paint["circle-stroke-color"] = "#000000";
    layerHover.layer.paint["circle-stroke-width"] = 2;
    layerHover.layer.paint["circle-stroke-opacity"] = [
      "case",
      ["boolean", ["feature-state", "hover"], false],
      1,
      0,
    ];
  } else if (layer.layer.type === "fill") {
    layerHover.layer.type = "line";
    layerHover.layer.paint = {
      "line-color": "#000000",
      "line-width": 2,
      "line-opacity": [
        "case",
        ["boolean", ["feature-state", "hover"], false],
        1,
        0,
      ],
    };
  }
  return layerHover;
}

export function sortLayersByOrder(layers) {
  const layerMap = new Map();
  const sortedLayers = [];
  const visited = new Set();

  layers.forEach((layer) => {
    layerMap.set(layer.layer.id, layer);
  });

  function visit(layerId) {
    if (visited.has(layerId)) return;
    visited.add(layerId);

    const layer = layerMap.get(layerId);
    if (layer && layer.before_id && layerMap.has(layer.before_id)) {
      visit(layer.before_id);
    }

    sortedLayers.push(layer);
  }

  layers.forEach((layer) => visit(layer.layer.id));

  return sortedLayers;
}

export function slugify(str) {
  str = str.replace(/^\s+|\s+$/g, ""); // trim leading/trailing white space
  str = str.toLowerCase(); // convert string to lowercase
  str = str
    .replace(/[^a-z0-9 -]/g, "") // remove any non-alphanumeric characters
    .replace(/\s+/g, "-") // replace spaces with hyphens
    .replace(/-+/g, "-"); // remove consecutive hyphens
  return str;
}
